import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { AzureDataExplorerDataset, ConnectionKind, IModel, Metamodel } from 'shell-models-lib';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataExplorerDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                table: '*',
                database: __IS_FABRIC_DPE__ ? '*' : undefined
            }
        }
    }
})
export class AzureDataExplorerDatasetAdapter extends TabularTypeDatasetAdapter<AzureDataExplorerDataset, Model.DatasetResource> {
    protected model(): IModel {
        return AzureDataExplorerDataset.MODEL;
    }

    protected override async _toResource(dataset: AzureDataExplorerDataset): Promise<Model.DatasetResource> {
        const modelDataset = await this._toResourceInternal(dataset, this.model().name, 'table');
        if (
            (__IS_FABRIC_DPE__ && dataset.linkedService.tridentConnectionKind === ConnectionKind.AZURE_DATA_EXPLORER)
                || this.context.adapterConfig.convertToFabric
        ) {
            modelDataset.properties.typeProperties.database = ValueAdapter.toResource(
                dataset,
                AzureDataExplorerDataset.DATABASE
            );
        }
        return modelDataset;
    }

    protected override async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: AzureDataExplorerDataset
    ): Promise<AzureDataExplorerDataset> {
        dataset = await this._toModelInternal(modelDatasetResource, dataset, this.model(), 'table');
        if (modelDatasetResource.properties?.typeProperties) {
            ValueAdapter.toModel(
                dataset,
                AzureDataExplorerDataset.DATABASE,
                modelDatasetResource.properties.typeProperties.database
            );
        }
        return dataset;
    }
}
